import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const Navbar = ({ agent, onGoHome }) => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [exclusiveLinkKey, setExclusiveLinkKey] = useState(null);

  const whatsappUrl = `https://wa.me/${agent?.whatsappNumber || '60163288120'}?text=${encodeURIComponent("Hi Nicole, I would need your help to find or rent a property.")}`;

  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (location.pathname.startsWith('/exclusive/')) {
      const parts = location.pathname.split('/');
      const key = parts[2];
      if (key) {
        try {
          sessionStorage.setItem('exclusive_link_key', key);
        } catch (e) {}
        setExclusiveLinkKey(key);
      }
    } else {
      try {
        const savedKey = sessionStorage.getItem('exclusive_link_key');
        if (savedKey) {
          setExclusiveLinkKey(savedKey);
        }
      } catch (e) {}
    }
  }, [location.pathname]);

  const handleNavClick = (e, targetHash) => {
    e.preventDefault();
    setMobileMenuOpen(false);

    if (targetHash === '#areas') {
      navigate('/all-areas');
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }

    if (targetHash === '#properties') {
      navigate('/all-listings');
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }

    if (targetHash === '#guides') {
      navigate('/guides');
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }

    if (targetHash === '#exclusive') {
      if (exclusiveLinkKey) {
        navigate(`/exclusive/${exclusiveLinkKey}`);
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
      return;
    }

    navigate('/');
    // Allow hash scrolling after navigation settles
    if (targetHash && targetHash !== '#home' && targetHash !== '#about') {
      setTimeout(() => {
        const el = document.querySelector(targetHash);
        if (el) el.scrollIntoView({ behavior: 'smooth' });
      }, 100);
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const isHomeActive = location.pathname === '/';
  const isAreasActive = location.pathname === '/all-areas' || location.pathname === '/areas' || location.pathname.startsWith('/area/');
  const isPropertiesActive = location.pathname === '/all-listings' || location.pathname === '/listings';
  const isGuidesActive = location.pathname === '/guides' || location.pathname.startsWith('/guides/');
  const isExclusiveActive = location.pathname.startsWith('/exclusive/');

  return (
    <header className="site-header">
      <div className="header-container">
        <a href="#home" onClick={(e) => handleNavClick(e, '#home')} className="brand-logo">
          <div className="brand-icon">
            <i className="bi bi-building-fill"></i>
          </div>
          <div className="brand-text-wrapper">
            <span className="brand-name">NICOLE PUA</span>
            <span className="brand-subtitle">妮可地产经纪</span>
          </div>
        </a>

        <ul className="nav-menu">
          <li><a href="#home" onClick={(e) => handleNavClick(e, '#home')} className={`nav-link ${isHomeActive ? 'active' : ''}`}>HOME</a></li>
          <li><a href="#areas" onClick={(e) => handleNavClick(e, '#areas')} className={`nav-link ${isAreasActive ? 'active' : ''}`}>AREAS</a></li>
          <li><a href="#properties" onClick={(e) => handleNavClick(e, '#properties')} className={`nav-link ${isPropertiesActive ? 'active' : ''}`}>PROPERTIES</a></li>
          <li><a href="#new-launch" onClick={(e) => handleNavClick(e, '#new-launch')} className="nav-link">NEW LAUNCH</a></li>
          <li><a href="#guides" onClick={(e) => handleNavClick(e, '#guides')} className={`nav-link ${isGuidesActive ? 'active' : ''}`}>GUIDES</a></li>
          <li><a href="#about" onClick={(e) => handleNavClick(e, '#about')} className="nav-link">ABOUT ME</a></li>
          <li><a href="#testimonials" onClick={(e) => handleNavClick(e, '#testimonials')} className="nav-link">TESTIMONIALS</a></li>
          <li><a href="#contact" onClick={(e) => handleNavClick(e, '#contact')} className="nav-link">CONTACT</a></li>
          <li>
            <a
              href="https://www.propertyguru.com.my/property-for-sale?listedById=901697876&locale=en"
              target="_blank"
              rel="noopener noreferrer"
              className="nav-link nav-link-propertyguru"
            >
              PROPERTY GURU
            </a>
          </li>
          {exclusiveLinkKey && (
            <li><a href={`/exclusive/${exclusiveLinkKey}`} onClick={(e) => handleNavClick(e, '#exclusive')} className={`nav-link ${isExclusiveActive ? 'active' : ''}`}>EXCLUSIVE</a></li>
          )}
        </ul>

        <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className="btn-whatsapp-header">
          <i className="bi bi-whatsapp"></i> WHATSAPP ME
        </a>

        <button 
          className="mobile-menu-btn" 
          onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          aria-label="Toggle Navigation"
        >
          <i className={`bi ${mobileMenuOpen ? 'bi-x' : 'bi-list'}`}></i>
        </button>
      </div>

      {mobileMenuOpen && (
        <div style={{
          background: 'var(--bg-dark)',
          padding: '1rem 2rem',
          borderTop: '1px solid rgba(255,255,255,0.1)',
          display: 'flex',
          flexDirection: 'column',
          gap: '0.75rem'
        }}>
          <a href="#home" onClick={(e) => handleNavClick(e, '#home')} className={`nav-link ${isHomeActive ? 'active' : ''}`}>HOME</a>
          <a href="#areas" onClick={(e) => handleNavClick(e, '#areas')} className={`nav-link ${isAreasActive ? 'active' : ''}`}>AREAS</a>
          <a href="#properties" onClick={(e) => handleNavClick(e, '#properties')} className={`nav-link ${isPropertiesActive ? 'active' : ''}`}>PROPERTIES</a>
          <a href="#new-launch" onClick={(e) => handleNavClick(e, '#new-launch')} className="nav-link">NEW LAUNCH</a>
          <a href="#guides" onClick={(e) => handleNavClick(e, '#guides')} className={`nav-link ${isGuidesActive ? 'active' : ''}`}>GUIDES</a>
          <a href="#about" onClick={(e) => handleNavClick(e, '#about')} className="nav-link">ABOUT ME</a>
          <a href="#contact" onClick={(e) => handleNavClick(e, '#contact')} className="nav-link">CONTACT</a>
          <a
            href="https://www.propertyguru.com.my/property-for-sale?listedById=901697876&locale=en"
            target="_blank"
            rel="noopener noreferrer"
            className="nav-link nav-link-propertyguru"
            onClick={() => setMobileMenuOpen(false)}
          >
            PROPERTY GURU
          </a>
          {exclusiveLinkKey && (
            <a href={`/exclusive/${exclusiveLinkKey}`} onClick={(e) => handleNavClick(e, '#exclusive')} className={`nav-link ${isExclusiveActive ? 'active' : ''}`}>EXCLUSIVE</a>
          )}
          <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className="btn-whatsapp-header" style={{ width: 'fit-content', marginTop: '0.5rem' }}>
            <i className="bi bi-whatsapp"></i> WHATSAPP ME
          </a>
        </div>
      )}
    </header>
  );
};

export default Navbar;
